import { HUYA_DANMU, HUYA_V_MAIN } from 'amkit3-modules/utils/services/urls'
import { jsonp, get } from 'amkit3-modules/utils/ajax'

const HUYA_V_MAIN_ROOT = '//v.huya.com/index.php'

export const timeList = (vid, beginTime, cb) => {
  jsonp(HUYA_DANMU + 'open/danmu/timelist.do', { vid, beginTime }, (err, data) => {
    if (err) {
      cb(err)
    } else {
      cb(null, data)
    }
  })
}

export const add = (vid, playTime, contents, size, color, mode, deathTime, cb) => {
  jsonp(
    HUYA_DANMU + 'auth/danmu/add.do',
    { vid, playTime, contents, size, color, mode, deathTime },
    (err, data) => {
      if (err) {
        cb(err)
      } else {
        if (data.error) {
          cb(new Error(data.msg || 'unknown error'), {}, data.optStatus)
        } else {
          cb(null, data.detail, data.optStatus)
        }
      }
    },
  )
}
/**
 * 获取现场弹幕接口
 */
export const liveDanmuList = (vid, st, et, cb) => {
  // 获取线上数据
  // let vidT = vid != 152257852 ? vid : 357032335
  // let url =  vid != 152163999 ? HUYA_V_MAIN : HUYA_V_MAIN_ROOT

  jsonp(HUYA_V_MAIN, { r: 'barrage/GetBarrageByTime', vid: vid, st, et }, (err, data) => {
    if (err) {
      cb(err)
    } else {
      cb(null, data)
    }
  })
}

export default {
  timeList,
  add,
  liveDanmuList,
}
